import { useUserLanguage } from '@/customHooks';
import { PriorityOption } from '@/graphql/generated';
import styled from 'styled-components';

type PriorityPillProps = {
  option: PriorityOption
}

const PillContainer = styled.div<{ $color: string, $backgroundColor: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.8rem;
  border-radius: 20px;
  font-size: 0.7rem;
  font-weight: bold;
  color: ${({ $color }) => $color};
  background-color: ${({ $backgroundColor }) => $backgroundColor};
`;

const optionMapping = (option: PriorityOption, language: 'es' | 'en') => {
  const mapping = {
    en: {
      MEDIUM: {
        text:'Medium',
        color: {
          font: '#FF971D',
          background: '#FF971D21'
        },
      },
      HIGH: {
        text:'High',
        color: {
          font: '#ff7878',
          background: '#ffd7d7'
        },
      },
      LOW: {
        text:'Low',
        color: {
          font: '#4a9462',
          background: '#d2f3dc'
        },
      },
    },
    es: {
      MEDIUM: {
        text:'Medio',
        color: {
          font: '#FF971D',
          background: '#FF971D21'
        },
      },
      HIGH: {
        text:'Alta',
        color: {
          font: '#ff7878',
          background: '#ffd7d7'
        },
      },
      LOW: {
        text:'Baja',
        color: {
          font: '#4a9462',
          background: '#d2f3dc'
        },
      },
    },
  }

  return mapping[language][option]
} 

export const PriorityPill = ({ option }: PriorityPillProps) => {
  const userLanguage = useUserLanguage()

  const optionMapped = optionMapping(option, userLanguage)
  return (
    <PillContainer $color={optionMapped.color.font} $backgroundColor={optionMapped.color.background}>
      {optionMapped.text}
    </PillContainer>
  );
}
